import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-383">
      <div className="max-w-5xl mx-auto" data-id="element-384">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-385">
          Lo que <span className="text-[#B87AFF]" data-id="element-386">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-387">
          <div className="bg-black border border-[#B87AFF]/30 rounded-2xl p-6" data-id="element-388">
            <h3 className="text-[#B87AFF] text-xl font-black mb-2" data-id="element-389">
              🧘 LOS 6 TOMOS
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-390">
              Para profesores de yoga de todos los niveles
            </p>
            <div className="space-y-4" data-id="element-391">
              <div className="flex items-center gap-3 text-white" data-id="element-392">
                <span className="text-xl" data-id="element-393">🟢</span>
                <div className="flex-1" data-id="element-394">
                  <span className="font-bold" data-id="element-395">Tomo 1 — El Despertar</span>
                  <span className="text-gray-300" data-id="element-396">
                    {' '}
                    Inicial (cero experiencia) · 20 secuencias de 60 min · 25
                    asanas base · Fichas de alumno · Planificador anual
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-397">
                <span className="text-xl" data-id="element-398">🟡</span>
                <div className="flex-1" data-id="element-399">
                  <span className="font-bold" data-id="element-400">Tomo 2 — Fluidez Consciente</span>
                  <span className="text-gray-300" data-id="element-401">
                    {' '}
                    Intermedio I (6–12 meses) · Vinyasa completo · 20 secuencias
                    · Progresión al flujo · Chaturanga sin lesión
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-402">
                <span className="text-xl" data-id="element-403">🟠</span>
                <div className="flex-1" data-id="element-404">
                  <span className="font-bold" data-id="element-405">
                    Tomo 3 — El Guerrero Interno
                  </span>
                  <span className="text-gray-300" data-id="element-406">
                    {' '}
                    Intermedio II (12–24 meses) · Inversiones básicas · Peak
                    Pose Method · 20 secuencias con pico de clase
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-407">
                <span className="text-xl" data-id="element-408">🔴</span>
                <div className="flex-1" data-id="element-409">
                  <span className="font-bold" data-id="element-410">Tomo 4 — Maestría y Vuelo</span>
                  <span className="text-gray-300" data-id="element-411">
                    {' '}
                    Avanzado (2+ años) · 15 Masterclasses 90 min · Handstand ·
                    Equilibrios avanzados · Escorpión
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-412">
                <span className="text-xl" data-id="element-413">🟣</span>
                <div className="flex-1" data-id="element-414">
                  <span className="font-bold" data-id="element-415">Tomo 5 — Yoga para la Vida</span>
                  <span className="text-gray-300" data-id="element-416">
                    {' '}
                    Poblaciones especiales · Adultos mayores · Lesiones ·
                    Restaurativo · Yoga terapéutico · Ansiedad
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-417">
                <span className="text-xl" data-id="element-418">⭐</span>
                <div className="flex-1" data-id="element-419">
                  <span className="font-bold" data-id="element-420">Tomo 6 — La Mente en Calma</span>
                  <span className="text-gray-300" data-id="element-421">
                    {' '}
                    Todos los niveles · 60 guiones de meditación · 12 técnicas
                    de pranayama · Filosofía · Gestión
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#B87AFF]/5 border border-[#B87AFF]/30 rounded-2xl p-8 text-center" data-id="element-422">
          <h3 className="text-[#B87AFF] text-xl font-black mb-6" data-id="element-423">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-424">
            <div className="flex items-start gap-2 text-left" data-id="element-425">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-426">✅</span>
              <span className="text-white text-sm" data-id="element-427">
                Planificación anual lista para usar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-428">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-429">✅</span>
              <span className="text-white text-sm" data-id="element-430">
                20–24 secuencias con objetivo, desarrollo y cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-431">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-432">✅</span>
              <span className="text-white text-sm" data-id="element-433">
                Criterios de progresión por nivel y edad
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-434">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-435">✅</span>
              <span className="text-white text-sm" data-id="element-436">
                Evaluaciones + rúbricas (escala de observación)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-437">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-438">✅</span>
              <span className="text-white text-sm" data-id="element-439">
                Fichas de seguimiento por alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-440">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-441">✅</span>
              <span className="text-white text-sm" data-id="element-442">
                Guías técnicas de cada asana con contraindicaciones
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-443">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-444">✅</span>
              <span className="text-white text-sm" data-id="element-445">
                Material original ProfePack®
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-446">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-447">✅</span>
              <span className="text-white text-sm" data-id="element-448">
                100% adaptado al profe de yoga argentino
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}